import {
  exportRequest,
  postRequest,
  postRequestForm,
  putRequest,
  getRequest,
  deleteRequest
} from "../utils/request";
/**
 * 电子工牌
 * */

//总部门
export const getDeptLevle = (level) => {
  return getRequest(`/badge/dept/level/${level}`)
}
//子部门
export const getDeptSubsById = (id) => {
  return getRequest(`/badge/dept/subs/${id}`)
}
//人员列表
export const getUserList = (params) => {
  return getRequest(`/badge/user/query`,params)
}
//同步数据
export const getSyncData = (params) => {
  return getRequest(`/badge/sync`,params)
}

//更新管辖区域
export const updateRegin = (data) => {
  return postRequest(`/badge/user/updateRegin`,data)
}

//人员详情
export const getUserInfo = (userId) =>{
  return getRequest(`/badge/user/detail/${userId}`)
};

//个人扫码记录
export const getUserRecord = (userId,params) => {
  return getRequest(`/badge/record/user/${userId}`,params)
}

//删除记录
export const delRecord = (id,params) => {
  return deleteRequest(`/badge/record/del/${id}`,params)
}

//扫码认证
export const recordConfirm = (params) => {
  return postRequestForm(`/badge/record/confirm/${params}`)
}
//评价
export const putFeedback = (data) => {
  return putRequest(`/badge/record/feedback`,data)
}
//扫码统计
export const getRecord = (params) => {
  return getRequest(`/badge/record/query`,params)
}

//现场照片查询
export const getRecordPhotos = (id,params) => {
  return getRequest(`/badge/record/photos/${id}`,params)
}
//用餐
export const getMealCode = (code) => {
  return postRequest(`/mealReport/getMeal/${code}`)
}
//确认用餐
export const confirmMeal = (user) => {
  return postRequest(`/mealReport/confirm/${user}`)
}
//直接吃餐
export const getMealEatInfo = (params) => {
  return postRequest(`/mealReport/eat`, params)
}
//代领已报餐
export const getOthersLead = (params) => {
  return postRequest(`/mealReport/getOthers`, params)
}
export const queryPageList = (data) =>{
  return postRequest(`/mealReport/list`,data)
}

//导出
export const exportMeals = (data) =>{
  return exportRequest(`/mealReport/exportMeals`,data)
}

export const getYishuCal = (params) => {
  return getRequest(`/yishu/cal/${params}`)
}
